import { SubscriptionType, RecurringType } from "_constants/SubscriptionConstants";

export const SubscriptionHelper = {
    GetSubscriptionTypeDescription,
    GetSubscriptionFeeDescription,
};

function GetSubscriptionTypeDescription(subscriptionType) {
    if (subscriptionType == null)
        return "";

    switch (subscriptionType) {
        case SubscriptionType.Subscription: return "";
        case SubscriptionType.Setup: return "One Time Fee";
        case SubscriptionType.Recurring: return "Recurring Fee";
        default: return "";
    }
}

function GetSubscriptionFeeDescription(subscriptionType, recurringType) {
    if (subscriptionType == null || (subscriptionType === SubscriptionType.Recurring && recurringType == null))
        return "";

    switch (subscriptionType) {
        case SubscriptionType.Subscription: return "Subscription Fee";
        case SubscriptionType.Setup: return "One Time Fee";
        case SubscriptionType.Recurring: {
            switch (recurringType) {
                case RecurringType.Monthly: return "Monthly Fee";
                case RecurringType.Annual: return "Yearly Fee";
                default: return "";
            }
        }
        default: return "";
    }
}